import { AppState } from "..";
import { StateUpdaterMap } from "src/model/manager/state-manager";

export interface NavigationActions {
    SET_INIT_PATH: string | null;
    SET_DEFAULT_INIT: void;
}

export const navigationActions: StateUpdaterMap<AppState, NavigationActions> = {
    SET_INIT_PATH: (path, _) => ({
        navigation: {
            initialPath: path,
            init: false
        }
    }),
    SET_DEFAULT_INIT: (_) => ({
        navigation: {
            initialPath: null,
            init: true
        }
    }),
}